import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import * as routes from 'constants/routeConstants';
import { useUserJourney } from '../../hooks/userJourney-Context';
import BackButton from '../../shared/components/BackButton/BackButton';
import styles from './loggedInView.module.scss';

const LoggedInView = () => {
  const [policyLockToken, setPolicyLockToken] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  const { userJourneyState } = useUserJourney();

  const backButtonPages = [
    routes.MY_COVER,
    routes.PRODUCT_UPGRADE_JOURNEY,
    routes.PRODUCT_UPGRADE_PAGE,
    routes.PERSONAL_DETAILS,
    routes.DOCUMENTS,
    routes.VEHICLE_DETAILS,
    routes.ACCOUNT_DETAILS,
    routes.MEMBER_SAVINGS,
    routes.FAQS,
    routes.TERMS_CONDITIONS,
    routes.FORGOT_PASSWORD,
    routes.UPDATE_PASSWORD,
    routes.PAYMENT_ISSUE,
    routes.CAR_INSURANCE,
    routes.VULNERABLE_CUSTOMERS,
    routes.MARKETING_PERMISSION,
  ];

  const isCarInsuranceRoute = location.pathname === routes.CAR_INSURANCE || location.pathname.startsWith(routes.CAR_INSURANCE);

  const checkPreviousPage = () => {
    // If the last page was the Login page re-route the customer to the Membership Overview page
    if (userJourneyState.pageHistory[userJourneyState.pageHistory.length - 2] === routes.LOGIN) {
      navigate(routes.ROOT);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={isCarInsuranceRoute ? styles.fullWidthContainer : styles.container}>
      {backButtonPages.includes(location.pathname) && <div className={isCarInsuranceRoute ? styles.backbuttonContainer : ''}><BackButton onClickHandler={checkPreviousPage} /></div>}
      <div>
        <Outlet context={[policyLockToken, setPolicyLockToken]} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoggedIn: state.session.isLoggedIn,
  policyLockToken: state.session.policyLockToken,
});

export default connect(mapStateToProps)(LoggedInView);
